export default __webpack_public_path__ + "static/media/21.caab46bb.png";